import React,{Component} from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom'
import Navbar from './components/layouts/Navbar';
import Dashboard from './components/dashboard/Dashboard'
import ProjectDetails from './components/projects/ProjectDetails'
import SignIn from './components/auth/SignIn'
import SignUp from './components/auth/SignUp'
import CreateProject from './components/projects/CreateProject'
import Footer from './components/layouts/Footer'

class App extends Component {
  render(){
      return (
          <BrowserRouter>
          <div className="app" >
            <Navbar/>
              <Switch>
                <Route exact path='/' component={Dashboard} />
                <Route path='/projects/:id' component={ProjectDetails} />
                <Route path='/signin' component={SignIn}/>
                <Route path='/signup' component={SignUp}/>
                <Route path='/create' component={CreateProject}/>
              </Switch>
              
          </div>
          <Footer />
        </BrowserRouter>
      
    );
  }
}
export default App;
